import { render } from "./settings.vue?vue&type=template&id=8eeb9d96&scoped=true"
import script from "./settings.vue?vue&type=script&lang=js"
export * from "./settings.vue?vue&type=script&lang=js"

import "./settings.vue?vue&type=style&index=0&id=8eeb9d96&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8eeb9d96"]])

export default __exports__